import React from 'react';

export default function EventVenueList({ venues, onBook }) {
    return (
        <div className="overflow-hidden rounded-xl border border-border/70 bg-white shadow-sm">
            {venues.map((venue, index) => (
                <div
                    key={venue.id ?? `${venue.location}-${index}`}
                    className="flex flex-col gap-4 border-b border-border/60 px-5 py-5 last:border-b-0 sm:flex-row sm:items-center sm:justify-between"
                >
                    <div className="min-w-0">
                        <h3 className="text-xl font-bold text-foreground">{venue.location}</h3>
                        {venue.city ? (
                            <p className="mt-1 text-sm text-muted-foreground">{venue.city}</p>
                        ) : null}
                        <div className="mt-2 flex flex-wrap items-center gap-3">
                            {venue.date ? (
                                <p className="text-sm font-medium text-foreground">{venue.date}</p>
                            ) : null}
                            {venue.time ? (
                                <span className="inline-block rounded border border-border/70 bg-muted/40 px-2.5 py-1 text-sm text-foreground">
                                    {venue.time}
                                </span>
                            ) : null}
                        </div>
                    </div>

                    <button
                        type="button"
                        onClick={() => onBook(venue, index)}
                        className="btn-gold inline-flex shrink-0 items-center justify-center px-6 py-2.5 rounded-full text-xs font-bold tracking-widest uppercase"
                    >
                        Buy ticket
                    </button>
                </div>
            ))}
        </div>
    );
}
